import { render } from "./CustomTextarea.vue?vue&type=template&id=588b7d82&ts=true"
import script from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTextarea.vue?vue&type=style&index=0&id=588b7d82&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/form/CustomTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "588b7d82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('588b7d82', __exports__)) {
    api.reload('588b7d82', __exports__)
  }
  
  module.hot.accept("./CustomTextarea.vue?vue&type=template&id=588b7d82&ts=true", () => {
    api.rerender('588b7d82', render)
  })

}


export default __exports__